// utils/getAddModalData.js

export const getModalConfig = (label) => {
    switch (label) {
      case 'Supplier':
        return {
          modalKey: 'newSupplier',
          data: [
            { key: "name", label: "Name", type: "text", placeholder: "Enter supplier name", width: "49%", required: true },
            { key: "currency", label: "Currency", type: "select", placeholder: "Select...", width: "49%", required: true },
            { key: "paymentType", label: "Payment Type", type: "select", placeholder: "Select...", width: "49%", required: true },
            { key: "accountPayable", label: "Account Payable", type: "select", placeholder: "Select...", width: "49%" },
            { key: "taxRule", label: "Tax Rule", type: "select", placeholder: "Select...", width: "49%", required: true, data: ['Tax Exempt', 'GST', 'PST', 'PST/GST', 'HST'] },
            { key: "defaultCarrier", label: "defaultCarrier", type: "select", placeholder: "Select...", width: "49%" },
            { key: "discount", label: "Discount", type: "number", placeholder: "Enter Discount", width: "49%" },
            { key: "taxNumber", label: "Tax Number", type: "number", placeholder: "Enter supplier name", width: "49%" },
            { key: "comments", label: "Comments", type: "textField", placeholder: "Enter comments", width: "100%" },
          ]
        };
  
      case 'Contacts':
        return {
          modalKey: 'newContact',
          data: [
            { key: "firstName", label: "First Name", type: "text", placeholder: "Enter name", width: { xs: '100%', md: "49%" }, required: true },
            { key: "lastName", label: "Last Name", type: "text", placeholder: "Enter name", width: { xs: '100%', md: "49%" }, required: true },
            { key: "jobTitle", label: "Job Title", type: "text", placeholder: "Enter job title", width: { xs: '100%', md: "49%" } },
            { key: "fax", label: "Fax", type: "text", placeholder: "Enter fax", width: { xs: '100%', md: "49%" } },
            { key: "phone", label: "Phone Number", type: "number", placeholder: "Enter phone", width: { xs: '100%', md: "49%" }, minLength: 10, maxLength: 10 },
            { key: "email", label: "Email", type: "email", placeholder: "Enter email", width: { xs: '100%', md: "49%" } },
            { key: "website", label: "Website", type: "text", placeholder: "Enter website", width: { xs: '100%', md: "49%" } },
            { key: "defaultForType", label: "Default for type", type: "toggle", width: { xs: '100%', md: "49%" } },
            { key: "comments", label: "Comments", type: "textField", placeholder: "Enter comments", width: "100%" },
          ]
        };
  
      case 'Terms':
        return {
          modalKey: 'newPaymentTerm',
          data: [
            { key: "name", label: "Name", type: "text", placeholder: "Enter name", width: "100%", required: true },
            { key: "methods", label: "Methods", type: "select", placeholder: "Enter Methods", width: "100%", required: true, data: ['Number of days', ' Day of the next month', 'Last day of the next month'] },
            { key: "days", label: "Days", type: "number", placeholder: "Enter days", width: "100%", required: true },
          ]
        };
  
      case 'Location':
        return {
          modalKey: 'newLocation',
          data: [
            { key: "location", label: "Location", type: "text", placeholder: "Enter Location", width: "100%", required: true },
          ]
        };
  
      case "Supplier's Address Line 1":
        return {
          modalKey: 'newSupplierAddress',
          data: getAddressFormFields(),
        };
  
      case "Shipping Address Line 1":
        return {
          modalKey: 'newShippingAddress',
          data: getAddressFormFields(),
        };
  
      default:
        return null;
    }
  };
  
  const getAddressFormFields = () => [
    { key: "addressType", label: "", type: "select", placeholder: "Select", width: "100%" },
    { key: "line1", label: "Line 1", type: "text", placeholder: "Enter Line 1", width: "100%", required: true },
    { key: "line2", label: "Line 2", type: "select", placeholder: "Enter Line 2", width: "100%" },
    { key: "citySuburb", label: "City/Suburb", type: "text", placeholder: "Enter City/Suburb", width: { xs: '100%', md: "49%" }, required: true },
    { key: "country", label: "Country", type: "text", placeholder: "Select", width: { xs: '100%', md: "49%" }, required: true },
    { key: "provinceState", label: "Province/State", type: "text", placeholder: "Enter Province/State", width: { xs: '100%', md: "49%" }, required: true },
    { key: "type", label: "Type", type: "select", placeholder: "Select", width: { xs: '100%', md: "49%" } },
    { key: "postalCode", label: "Postal code/ZIP", type: "text", placeholder: "Enter Postal code/ZIP*", width: { xs: '100%', md: "49%" }, required: true },
    { key: "defaultForType", label: "Default for type", type: "toggle", width: { xs: '100%', md: "49%" } },
    { key: "comments", label: "Comments", type: "text", placeholder: "Enter Comments", width: "100%" },
  ];
  